import type { ChangeAdminPasswordPayload } from '../entities/settings.entity'
import type { SettingsRepository } from '../repositories/settings_repository'

export class ChangeAdminPasswordUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(payload: ChangeAdminPasswordPayload): Promise<void> {
    return this.repository.changePassword(payload)
  }
}
